import { Controller } from '@hotwired/stimulus'

// Toggles a `data-stuck` attribute on the element when its sentinel sibling
// leaves the viewport — i.e. when the sticky element is actually pinned.
export default class extends Controller {
  static targets = ['sentinel']

  connect() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.element.toggleAttribute('data-stuck', !entry.isIntersecting)
      },
      { threshold: 0 }
    )
    if (this.hasSentinelTarget) this.observer.observe(this.sentinelTarget)
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
